module.exports = __webpack_public_path__ + "img/sprainedwrist.bbc8b2c4.gif";